const e=async(e,t,n)=>{let{data:r}=await e.get(`/apps/${t}/system-roles/${n}`);return r};export{e as getSystemRole};
//# sourceMappingURL=get-system-role.mjs.map